// Date 2023-12-13 10:13:14

import jscConfigurationEdit from "@/views/emAssistant/jsc/JscConfigurationEdit.vue";
import jscConfigurationList from "@/views/emAssistant/jsc/JscConfigurationList.vue";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
//公用组件注册
//自定义页面注册
    {
        path: "/emAssistant/jsc/jscConfigurationEdit",
        name: "jscConfigurationEdit",
        component: jscConfigurationEdit,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    },
    {
        path: "/emAssistant/jsc/jscConfigurationList",
        name: "jscConfigurationList",
        component: jscConfigurationList,
        props: (route) => ({prop_inline: route.query.inline}),
        meta: metaObject
    }
]
